import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { ProjectFindInterface } from '@zaoblako/shared/modules/project/dto/project/project-find.dto';
import { StatusLabelComponent } from '@zaoblako/web/shared/components/status-label/status-label.component';
import { MultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/multi-select/multi-select.component';

@Component({
  selector: 'crm-project-multi-select',
  standalone: true,
  imports: [CommonModule, MultiSelectComponent, StatusLabelComponent],
  templateUrl: './project-multi-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectMultiSelectComponent {
  @Input() public projects: ProjectFindInterface[] = [];
  @Input() public selectedProjects: ProjectFindInterface[] = [];
  @Input() public isError = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public disabled: boolean;
  @Input() public appendTo: string;

  @Output() public selectedProjectsChange = new EventEmitter<ProjectFindInterface[]>();

  public toProject(project: any): ProjectFindInterface {
    return project as ProjectFindInterface;
  }
}
